import Hero from '@/travo/components/sections/Hero';
import TourBand from '@/travo/components/sections/TourBand';
import Features from '@/travo/components/sections/Features';
import CheckIns from '@/travo/components/sections/CheckIns';
import Passport from '@/travo/components/sections/Passport';
import PlanTrip from '@/travo/components/sections/PlanTrip';
import HowItWorks from '@/travo/components/sections/HowItWorks';
import FriendsPostcard from '@/travo/components/sections/FriendsPostcard';
import FAQ from '@/travo/components/sections/FAQ';
import FinalCTA from '@/travo/components/sections/FinalCTA';
import { SEO } from '@/travo/components/SEO';
import TravoAppSchema from '@/travo/components/TravoAppSchema';
import {
  BreadcrumbSchema,
  OrganizationSchema,
  WebsiteSchema,
  WebPageSchema,
  FAQSchema,
  HowToSchema,
  VideoObjectSchema
} from '@/shared/seo';
import { localizePath, useCopy, useLocale } from '@/travo/i18n';
import { APP_IDS, SITE_URL } from '@/shared/site';
import { ROUTES } from '@/travo/routes';

const HomePage = () => {
  const copy = useCopy();
  const locale = useLocale();

  return (
    <>
      <SEO {...copy.seo.home} path={ROUTES.home} />
      <OrganizationSchema />
      <WebsiteSchema />
      <BreadcrumbSchema items={[{ name: 'Travo', url: SITE_URL + localizePath(locale, ROUTES.home) }]} />
      <WebPageSchema
        name={copy.seo.home.title}
        description={copy.seo.home.description}
        url={SITE_URL + localizePath(locale, ROUTES.home)}
        inLanguage={copy.htmlLang}
        about={APP_IDS.travo}
      />
      <TravoAppSchema description={copy.schema.appDescription} featureList={copy.schema.featureList} />
      <FAQSchema items={copy.faq} />
      <HowToSchema
        name={copy.how.title}
        description={copy.seo.home.description}
        steps={copy.how.steps.map((step, i) => ({ position: i + 1, name: step.title, text: step.body }))}
        totalTime="PT5M"
      />
      <VideoObjectSchema
        name={copy.schema.videoName}
        description={copy.schema.videoDescription}
        thumbnailUrl="https://www.travolabs.com/og-image.png"
        uploadDate="2026-05-15"
        contentUrl="https://youtube.com/shorts/h2EHHHPlZRk"
      />
      <main>
        <Hero />
        <TourBand />
        <Features />
        <CheckIns />
        <Passport />
        <PlanTrip />
        <HowItWorks />
        <FriendsPostcard />
        <FAQ />
        <FinalCTA />
      </main>
    </>
  );
};

export default HomePage;
